import { render, staticRenderFns } from "./FormPic.vue?vue&type=template&id=286da4e1&scoped=true"
import script from "./FormPic.vue?vue&type=script&lang=ts"
export * from "./FormPic.vue?vue&type=script&lang=ts"
import style0 from "./FormPic.vue?vue&type=style&index=0&id=286da4e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286da4e1",
  null
  
)

export default component.exports